
import { CityPageTemplate } from '@/components/seo/CityPageTemplate';
import { Laptop, Music, Zap } from 'lucide-react';

const AustinPage = () => {
  return (
    <CityPageTemplate
      city="Austin"
      state="Texas"
      stateAbbr="TX"
      population="965,000+"
      majorIndustries={["technology", "startups", "music/entertainment", "healthcare", "clean energy"]}
      businessChallenges={[
        "Startup scaling and rapid hiring needs",
        "Competitive tech talent market",
        "Managing remote and hybrid workforces",
        "Stock option and equity compensation complexity",
        "Creative industry employment classification"
      ]}
      peoSolutions={[
        "Startup-friendly HR solutions and pricing",
        "Tech talent attraction and retention strategies",
        "Remote workforce management and compliance",
        "Equity compensation administration",
        "Creative contractor vs. employee guidance"
      ]}
      localBusinessTypes={[
        { name: "Technology", description: "Software, SaaS, mobile apps, AI" },
        { name: "Startups", description: "Early-stage companies, incubators" },
        { name: "Music/Entertainment", description: "Studios, venues, creative agencies" },
        { name: "Clean Energy", description: "Solar, wind, energy storage" }
      ]}
      metaDescription="Find the best PEOs in Austin with The PEO App. Compare quotes from top Austin Professional Employer Organizations offering specialized HR solutions for startups, tech companies, and creative businesses."
      keyFeatures={[
        {
          icon: Laptop,
          title: "Startup Ecosystem Support",
          description: "Tailored HR solutions for Austin's thriving startup community with flexible scaling and cost-effective benefits."
        },
        {
          icon: Music,
          title: "Creative Industry Expertise",
          description: "Specialized HR services for Austin's music and entertainment industry including contractor classification and IP protection."
        },
        {
          icon: Zap,
          title: "Tech Innovation Focus",
          description: "Advanced HR technology and equity compensation solutions for Austin's rapidly growing tech sector."
        }
      ]}
    />
  );
};

export default AustinPage;
